
























































































import {
    defineComponent,
    computed,
    ref,
    PropType
} from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import { alarm, sensor } from "@/store";
import UserSettingsViewModel from "../../../models/UserSettingsViewModel";

export default defineComponent({
    components: {
        SensorHeader: () =>
            import(/* webpackChunkName: "components" */ "./SensorHeader.vue"),
        CurrentDialog: () =>
            import(/* webpackChunkName: "components" */ "../Dialogs/CurrentDialog.vue"),
        EditCurrentDialog: () =>
            import(/* webpackChunkName: "components" */ "../Dialogs/EditCurrentDialog.vue"),
        ConfirmDialog: () =>
            import(/* webpackChunkName: "settings" */ "../Dialogs/ConfirmDialog.vue")
    },
    props: {
        value: { type: Object as PropType<AttachedDeviceModel> },
        threshold: { type: Number, required: true }
    },
    setup(props, { emit }) {
        const showCurrentDialog = ref(false);
        const showCurrentEditThresholdDialog = ref(false);
        const showCalibrateDialog = ref(false);
        const rawCurrent = computed(() => {
            const alarmStatus = alarm.alarmStatus;
            const vSupplies = alarmStatus && alarmStatus.VSupplies;
            const raw = vSupplies && vSupplies[0] && vSupplies[0].I1;
            return raw != null ? raw : null;
        });

        const currentValue = computed(() => {
            const value = rawCurrent.value;
            const num = parseFloat(value != null ? value : "");
            return isNaN(num) ? null : num;
        });

        const connected = computed(() => {
            // Match alarm module logic: consider connected if absolute value of current < 50
            return currentValue.value !== null && Math.abs(currentValue.value) < 50;
        });

        const paired = computed<boolean>(() =>
            !!props.value?.attachedDeviceId
        );

        const pumpStatus = computed(() => {
            // pumpIsRunning = true means current >= threshold
            return currentValue.value !== null && currentValue.value >= props.threshold;
        });

        const currentDisplay = computed(() => {
            if (!connected.value) return "—.- A";
            return `${currentValue.value.toFixed(1)} A`;
        });

        const requestAdcCalibration = () => {
            sensor.RequestAdcCalibration(0); // 0 is channel for current sensor
        };

        const handleOnSaveCurrentThreshold = (model: UserSettingsViewModel) => {
            props.threshold = model.bilgeThreshold;
            emit("OnNewCurrentThreshold", model);
        };

        return {
            connected,
            paired,
            pumpStatus,
            currentDisplay,
            showCurrentDialog,
            showCalibrateDialog,
            requestAdcCalibration,
            showCurrentEditThresholdDialog,
            handleOnSaveCurrentThreshold
        };
    }
});
